(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2238],{

/***/ 8718:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[handle]",
      function () {
        return __webpack_require__(36332);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Product; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(35230);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/snippets/icons/DarkCircleCheckmark.jsx
var DarkCircleCheckmark = __webpack_require__(64647);
;// CONCATENATED MODULE: ./src/utilities/YotpoScript.js
var YotpoScript = function() {
    if (true) {
        var e = document.createElement("script");
        e.type = "text/javascript", e.async = true, e.src = "https://staticw2.yotpo.com/lQ4CeYzdw3OtWNNjZlNguLjoyPQUjQ9VCuuFdAnJ/widget.js";
        e.id = "YotpoBaseScript";
        var t = document.getElementsByTagName("script")[0];
        var b = document.getElementById("YotpoBaseScript");
        if (!b) {
            t.parentNode.insertBefore(e, t);
        }
    }
    CheckYotpoInitialized();
};
var CheckYotpoInitialized = function() {
    setTimeout(function() {
        if ( true && window.yotpo) {
            window.yotpoAPI = new Yotpo.API(yotpo);
            yotpoAPI.refreshWidgets();
        } else {
            CheckYotpoInitialized();
        }
    }, 1000);
};

// EXTERNAL MODULE: ./src/utilities/Helper.js
var Helper = __webpack_require__(41717);
;// CONCATENATED MODULE: ./src/snippets/products/AfterPay.jsx


function AfterPay(param) {
    var price = param.price, variantId = param.variantId, currency = param.currency;
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react.useEffect)(function() {
        var applyAfterPayStyles = function() {
            var afterpayShadow = document.getElementById("after-pay").shadowRoot;
            var style = document.createElement("style");
            style.textContent = "\n        :host {\n          margin: 0;\n        }\n\n        template {\n          font-size: 14px;\n          position: relative;\n          left: -12px;\n          top: 0px;\n          color: transparent;\n\n          background-image: url('/images/info-icon.png');\n          background-size: 100%;\n          width: 16px;\n        }\n\n        .afterpay-paragraph {\n          font-size: 14px;\n          text-align: center;\n          line-height: 10px;\n        }\n\n        .afterpay-logo {\n          margin: 0;\n        }\n\n        .afterpay-logo.brand-afterpay, .afterpay-logo.brand-afterpay svg {\n          width: 90px !important;\n          margin-left: -5px;\n        }\n\n        .afterpay-link {\n          margin-left: 10px;\n          font-size: 0px;\n        }\n\n        .afterpay-link:before {\n          font-size: 14px;\n          outline: none;\n          border-bottom: 1px solid black;\n          padding-bottom: 0px;\n          font-family: Gotham, sans-serif;\n          position: relative;\n          left: -8px;\n        }\n\n        .afterpay-link {\n          outline: none;\n        }\n\n        .afterpay-logo.black-on-mint .afterpay-logo-badge-background {\n          fill: transparent !important;\n        }\n\n        @media only screen and (max-width: 600px) {\n          .afterpay-logo.black-on-mint .afterpay-logo-badge-background {\n            fill: transparent !important;\n          }\n        }\n\n        @media only screen and (max-width: 1024px) {\n          .afterpay-paragraph {\n            font-size: 12px;\n          }\n        }\n      ";
            afterpayShadow.append(style);
        };
        applyAfterPayStyles();
        setMounted(true);
        var checkExist = setInterval(function() {
            if (document.getElementById("after-pay") && document.getElementById("after-pay").shadowRoot) {
                applyAfterPayStyles();
                clearInterval(checkExist);
            }
        }, 100);
    }, [
        variantId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mt-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("afterpay-placement", {
                "data-locale": "en_US",
                "data-currency": currency || "USD",
                "data-amount": price,
                "data-modal-theme": "white",
                id: "after-pay"
            }),
            !mounted && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-background absolute inset-0 h-full bg-white"
            })
        ]
    });
}
/* harmony default export */ var products_AfterPay = (AfterPay);

// EXTERNAL MODULE: ./src/snippets/products/ProductGallery.jsx
var ProductGallery = __webpack_require__(3052);
// EXTERNAL MODULE: ./src/snippets/products/ProductInformation.jsx + 3 modules
var ProductInformation = __webpack_require__(53748);
// EXTERNAL MODULE: ../node_modules/isomorphic-fetch/fetch-npm-browserify.js
var fetch_npm_browserify = __webpack_require__(84447);
// EXTERNAL MODULE: ./public/icons/icon-close.svg
var icon_close = __webpack_require__(23278);
// EXTERNAL MODULE: ./public/icons/error-icon.svg
var error_icon = __webpack_require__(48438);
// EXTERNAL MODULE: ./src/hooks/useKlaviyoApi.js
var useKlaviyoApi = __webpack_require__(33439);
;// CONCATENATED MODULE: ./src/snippets/products/BackInStockModal.jsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







function BackInStockModal(param) {
    var selectedVariant = param.selectedVariant, product = param.product;
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(""), message = ref2[0], setMessage = ref2[1];
    var ref3 = (0,react.useState)(false), isOpen = ref3[0], setIsOpen = ref3[1];
    var backInStockSubscription = (0,useKlaviyoApi/* useKlaviyoApi */.a)().backInStockSubscription;
    var handleClick = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(event) {
            var variant;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        setLoading(true);
                        variant = selectedVariant.legacyResourceId;
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return backInStockSubscription({
                            email: email,
                            variantId: variant,
                            callback: function(response) {
                                if (response == "success") {
                                    var successMessage = "Success! We'll notify you when this product is in stock. We don't share your address with anybody else.";
                                    setMessage(successMessage);
                                    setEmail("");
                                } else {
                                    setMessage("Uh something went wrong");
                                }
                                setLoading(false);
                            }
                        });
                    case 7:
                        _ctx.next = 14;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](4);
                        console.log(_ctx.t0);
                        setMessage("Uh something went wrong");
                        setLoading(false);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    9
                ]
            ]);
        }));
        return function handleClick(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var openModal = function() {
        setIsOpen(true);
    };
    var closeModal = function() {
        setEmail("");
        setIsOpen(false);
    };
    (0,react.useEffect)(function() {
        document.addEventListener("backInStockModal:open", openModal);
        return function() {
            document.removeEventListener("backInStockModal:open", openModal);
        };
    });
    if (!selectedVariant) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "BackInStockModal fixed top-0 left-0 z-[100000] flex h-full w-full items-center justify-center ".concat(isOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal-body relative z-[101] mx-auto max-h-[80%] w-[1200px] max-w-[80%] overflow-y-auto bg-white p-4",
                style: {
                    width: "660px",
                    maxWidth: "90%",
                    textAlign: "center",
                    paddingBottom: "30px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "modal-header w-full text-right",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "backInStockModalClose",
                            onClick: closeModal,
                            "aria-label": "back In Stock modal close",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_close/* default */.Z, {})
                        }),
                         true && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "modal-body-content gap-6",
                            style: {
                                textAlign: "center",
                                margin: "auto"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "mb-0 text-center text-h5 font-light md:text-h3",
                                        children: "Email Me When Available"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        style: {
                                            display: "block",
                                            textAlign: "center",
                                            my: 15,
                                            maxWidth: "300px",
                                            margin: "15px auto",
                                            color: "#000000",
                                            fontSize: "14px",
                                            marginBottom: "36px"
                                        },
                                        children: "Register your email address below to receive an email as soon as this becomes available again."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            alignItems: "baseline",
                                            mx: "auto",
                                            maxWidth: "660px",
                                            gridGap: "15px",
                                            display: "grid",
                                            gridTemplateColumns: "1fr"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "email",
                                                value: email,
                                                onChange: function(event) {
                                                    return setEmail(event.target.value);
                                                },
                                                placeholder: "Email Address",
                                                "aria-label": "Email Address",
                                                style: {
                                                    border: "1px solid #979797",
                                                    maxWidth: "430px",
                                                    width: "100%",
                                                    margin: "auto",
                                                    padding: "12px 20px",
                                                    outline: "none",
                                                    "::placeholder": {
                                                        color: "#000000"
                                                    }
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "button",
                                                "aria-label": "Submit Back In Stock",
                                                className: "button button--primary mt-5 block flex w-full justify-center",
                                                style: {
                                                    maxWidth: "430px",
                                                    width: "100%",
                                                    margin: "auto"
                                                },
                                                disabled: loading,
                                                onClick: handleClick,
                                                children: "email me when available"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            textAlign: "left",
                                            marginTop: 20,
                                            fontSize: "14px",
                                            paddingBottom: 0,
                                            marginBottom: 0,
                                            maxWidth: "430px",
                                            width: "100%",
                                            margin: "24px auto 0px auto",
                                            display: "grid",
                                            gridTemplateColumns: "auto 1fr",
                                            gridGap: "10px"
                                        },
                                        children: [
                                            (message === null || message === void 0 ? void 0 : message.includes("Success")) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/success-icon.png",
                                                style: {
                                                    width: "16px",
                                                    marginTop: "3px"
                                                },
                                                alt: "success icon",
                                                width: "16",
                                                height: "16"
                                            }),
                                            message && !(message === null || message === void 0 ? void 0 : message.includes("Success")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(error_icon/* default */.Z, {
                                                style: {
                                                    marginTop: "3px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                style: {
                                                    color: (message === null || message === void 0 ? void 0 : message.includes("Success")) ? "#218246" : "#e23f3f"
                                                },
                                                children: message
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "modalBackdrop z-103 fixed top-0 left-0 h-full w-full cursor-pointer bg-black ".concat(isOpen ? "pointer-events-auto opacity-50" : "opacity-0"),
                onClick: closeModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "sr-only",
                    children: "Close Quick View"
                })
            })
        ]
    });
}
/* harmony default export */ var products_BackInStockModal = (BackInStockModal);

;// CONCATENATED MODULE: ./src/snippets/products/SubscriptionBenefitsModal.jsx



function SubscriptionBenefitsModal(param) {
    var modalContent = param.modalContent;
    var ref, ref1;
    var ref2 = (0,react.useState)(false), isOpen = ref2[0], setIsOpen = ref2[1];
    var openModal = function() {
        setIsOpen(true);
    };
    var closeModal = function() {
        setIsOpen(false);
    };
    (0,react.useEffect)(function() {
        document.addEventListener("subscriptionModal:open", openModal);
        return function() {
            document.removeEventListener("subscriptionModal:open", openModal);
        };
    });
    if (modalContent == null || (modalContent === null || modalContent === void 0 ? void 0 : (ref = modalContent.contentList) === null || ref === void 0 ? void 0 : ref.length) === 0) {
        return false;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "fixed top-0 left-0 z-[100000] flex h-full w-full items-center justify-center ".concat(isOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative z-[101] mx-auto max-h-[80%] w-[1200px] max-w-[80%] overflow-y-auto bg-white p-8",
                style: {
                    width: "660px",
                    maxWidth: "90%",
                    textAlign: "center",
                    paddingBottom: "30px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-header",
                        children: [
                            (modalContent === null || modalContent === void 0 ? void 0 : modalContent.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "font-tiempos text-h4-m md:text-h4 m-0",
                                children: modalContent === null || modalContent === void 0 ? void 0 : modalContent.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "absolute right-4 top-4",
                                type: "button",
                                onClick: closeModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_close/* default */.Z, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-6 lg:mt-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid gap-6 lg:grid-cols-3 lg:gap-10",
                            style: {
                                textAlign: "center",
                                margin: "auto"
                            },
                            children: modalContent === null || modalContent === void 0 ? void 0 : (ref1 = modalContent.contentList) === null || ref1 === void 0 ? void 0 : ref1.map(function(content, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-center justify-start gap-2 max-w-xs mx-auto",
                                    children: [
                                        content.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: content.icon.src,
                                            alt: content.icon.alt,
                                            width: "40",
                                            height: "40"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "sub-small m-0",
                                            children: content.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-small m-0",
                                            children: content.description
                                        })
                                    ]
                                }, index);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "modalBackdrop z-103 fixed top-0 left-0 h-full w-full cursor-pointer bg-black ".concat(isOpen ? "pointer-events-auto opacity-50" : "opacity-0"),
                onClick: closeModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "sr-only",
                    children: "Close Benefits Modal"
                })
            })
        ]
    });
}
/* harmony default export */ var products_SubscriptionBenefitsModal = (SubscriptionBenefitsModal);

// EXTERNAL MODULE: ./src/utilities/Metafields.js
var Metafields = __webpack_require__(86501);
// EXTERNAL MODULE: ./src/snippets/icons/ArrowUp.jsx
var ArrowUp = __webpack_require__(90107);
;// CONCATENATED MODULE: ./src/snippets/components/BackToTop.jsx



function BackToTop(param) {
    var scrollReference = param.scrollReference;
    var ref = (0,react.useState)(0), scrollPosition = ref[0], setScrollPosition = ref[1];
    var ref1 = (0,react.useState)(false), enableButton = ref1[0], setEnableButton = ref1[1];
    var updateScrollPosition = function(e) {
        setScrollPosition(window.scrollY);
    };
    var scrollTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", updateScrollPosition);
        return function() {
            window.removeEventListener("scroll", updateScrollPosition);
        };
    }, []);
    (0,react.useEffect)(function() {
        setEnableButton(scrollPosition >= scrollReference.current.clientHeight);
    }, [
        scrollPosition
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed right-5 ".concat(enableButton ? "pointer-events-all top-52 opacity-100" : "pointer-events-none top-12  opacity-0", " z-10 hidden lg:flex h-11 w-11 cursor-pointer items-center justify-center rounded-full border border-black bg-black transition-all duration-300 ease-in-out"),
        onClick: scrollTop,
        "aria-hidden": true,
        tabIndex: "-1",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* ArrowUp */.a, {
            className: "text-white"
        })
    });
};

;// CONCATENATED MODULE: ./src/snippets/products/ProductSticky.jsx



function ProductSticky(param) {
    var settings = param.settings, scrollReference = param.scrollReference, product = param.product, selectedPlan = param.selectedPlan, selectedPlanId = param.selectedPlanId, sellingPlanPrice = param.sellingPlanPrice, variantPrice = param.variantPrice, comparePrice = param.comparePrice;
    var ref;
    var ref1 = (0,react.useState)(0), scrollPosition = ref1[0], setScrollPosition = ref1[1];
    var ref2 = (0,react.useState)(false), enableButton = ref2[0], setEnableButton = ref2[1];
    var buttonRef = (0,react.useRef)(null);
    var metafieldMap = (0,react.useMemo)(function() {
        return (0,Metafields/* getMetafieldMap */.x)(product);
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var ingredient = metafieldMap.custom_ingredient_title;
    var productTitle = metafieldMap.custom_product_title || product.title;
    var comparePriceText = (metafieldMap === null || metafieldMap === void 0 ? void 0 : metafieldMap.custom_compare_at_price) || "";
    var firstMedia = product === null || product === void 0 ? void 0 : product.media.find(function(media) {
        var image = null;
        if ((media === null || media === void 0 ? void 0 : media.mediaContentType) === "IMAGE") {
            image = media;
        }
        return image;
    });
    var updateScrollPosition = function() {
        setScrollPosition(window.scrollY);
    };
    var scrollTop = function() {
        buttonRef.current.blur();
        window.scrollTo({
            top: scrollReference.current.offsetTop - 100,
            behavior: "smooth"
        });
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", updateScrollPosition);
        return function() {
            window.removeEventListener("scroll", updateScrollPosition);
        };
    }, []);
    (0,react.useEffect)(function() {
        setEnableButton(scrollPosition >= scrollReference.current.offsetTop + scrollReference.current.clientHeight);
    }, [
        scrollPosition
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-sticky-bar fixed top-[93px] left-0 right-0 z-10 flex w-full transform justify-between border-b border-grey-7 bg-white px-2 py-2 transition-all duration-300 ease-in-out lg:top-[82px] lg:px-12 ".concat(enableButton ? "pointer-events-auto translate-y-0 opacity-100" : "pointer-events-none -translate-y-full opacity-0"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-2 pr-3 lg:pr-0",
                children: [
                    firstMedia && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden h-16 w-16 lg:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "responsive-image pb-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: firstMedia.image.src,
                                alt: firstMedia.image.altText,
                                width: "64",
                                height: "64"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            ingredient && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-0 hidden font-tiempos text-h6-m italic text-black lg:block",
                                children: ingredient
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-0 font-tiempos text-sm md:text-h5",
                                children: productTitle
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center gap-3 lg:gap-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex gap-1",
                        children: selectedPlan && selectedPlanId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "ml-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "product-original-price ml-4 font-hafferBold text-[14px] text-[#757575] line-through",
                                    children: "".concat((settings === null || settings === void 0 ? void 0 : (ref = settings.discountHighlight) === null || ref === void 0 ? void 0 : ref.enableDiscountHighlight) ? comparePrice || variantPrice : variantPrice)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "ml-2 font-hafferBold text-[14px]",
                                    children: "".concat(sellingPlanPrice)
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                comparePrice && comparePriceText === "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "m-0 font-hafferBold text-xs text-grey-3 line-through lg:text-h6-m",
                                    children: comparePrice
                                }),
                                comparePriceText !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "m-0 font-hafferBold text-xs text-grey-3 lg:text-h6-m",
                                    children: comparePriceText
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "m-0 font-hafferBold text-xs text-black lg:text-h6-m",
                                    children: variantPrice
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "button button--checkout min-w-[90px] md:min-w-[160px] lg:min-w-[260px]",
                        onClick: scrollTop,
                        ref: buttonRef,
                        children: "buy"
                    })
                ]
            })
        ]
    });
};
ProductSticky.displayName = "ProductSticky";

// EXTERNAL MODULE: ./src/hooks/index.js + 13 modules
var hooks = __webpack_require__(98702);
;// CONCATENATED MODULE: ./src/snippets/globals/layout/ProductEmailSignup.jsx
function ProductEmailSignup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProductEmailSignup_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProductEmailSignup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProductEmailSignup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var validateEmail = function(email) {
    return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
};
function ProductEmailSignup() {
    var ref;
    var ref1 = (0,react.useState)(""), email = ref1[0], setEmail = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react.useState)(""), message = ref3[0], setMessage = ref3[1];
    var settings = (0,dist.useSettings)();
    var subscribeToList = (0,useKlaviyoApi/* useKlaviyoApi */.a)().subscribeToList;
    var emailSettings = settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : ref.productEmail;
    var listId = (emailSettings === null || emailSettings === void 0 ? void 0 : emailSettings.listId) || "HQmQ53";
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = ProductEmailSignup_asyncToGenerator(runtime_default().mark(function _callee(e) {
            var isEmailValid;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (!isLoading) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        if (email) {
                            _ctx.next = 7;
                            break;
                        }
                        setMessage("Email is required");
                        setTimeout(function() {
                            setMessage("");
                        }, 3000);
                        return _ctx.abrupt("return");
                    case 7:
                        isEmailValid = validateEmail(email);
                        if (isEmailValid) {
                            _ctx.next = 12;
                            break;
                        }
                        setMessage("Email is invalid");
                        setTimeout(function() {
                            setMessage("");
                        }, 3000);
                        return _ctx.abrupt("return");
                    case 12:
                        setIsLoading(true);
                        _ctx.next = 15;
                        return subscribeToList({
                            email: email,
                            listId: listId,
                            source: "Coming Soon Product Form",
                            callback: function(response) {
                                if (response === "success") {
                                    setIsLoading(false);
                                    setMessage((emailSettings === null || emailSettings === void 0 ? void 0 : emailSettings.successMessage) || "Email submitted!");
                                    setEmail("");
                                    setTimeout(function() {
                                        setMessage("");
                                    }, 4000);
                                } else {
                                    setIsLoading(false);
                                    setEmail("");
                                    setMessage("Please try again later");
                                }
                            }
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        email,
        isLoading,
        message
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            (emailSettings === null || emailSettings === void 0 ? void 0 : emailSettings.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-4 mb-2 font-hafferBold text-left",
                children: emailSettings === null || emailSettings === void 0 ? void 0 : emailSettings.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-4 flex items-center justify-between bg-white border-grey-5 border-[1px] p-1 pr-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-input relative flex w-[20.625rem] flex-col self-start",
                        style: {
                            marginBottom: message ? "1.75rem" : "0"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                name: "email-address",
                                id: "email-address",
                                type: "email",
                                value: email,
                                placeholder: "Email Address",
                                required: true,
                                style: {
                                    outline: "none"
                                },
                                className: "w-full cursor-pointer border-0 border-black bg-transparent py-2 px-4 text-grey-3 placeholder-grey-3 transition-all placeholder-shown:border-grey-7 placeholder-shown:text-grey-3 hover:border-black hover:text-black hover:placeholder-black focus:rounded-none focus:text-black focus:placeholder-black focus:outline-ada-outline",
                                onChange: function(e) {
                                    return setEmail(e.target.value);
                                },
                                "aria-label": "Email Address"
                            }),
                            message && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-xsmall absolute top-[calc(100%+0.5rem)] w-full px-4 text-black",
                                children: message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        "aria-label": "submit",
                        className: "min-w-[auto] text-center border-button-primary-bg bg-button-primary-bg text-white hover:bg-button-primary-bg-hover hover:border-button-primary-bg-hover button--small lowercase",
                        style: message ? {
                            marginBottom: "auto",
                            marginTop: "5px"
                        } : {},
                        onClick: handleSubmit,
                        children: (emailSettings === null || emailSettings === void 0 ? void 0 : emailSettings.buttonText) || "Submit"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var layout_ProductEmailSignup = (ProductEmailSignup);

;// CONCATENATED MODULE: ./src/snippets/products/BuyWithPrimeReviews.jsx


function BuyWithPrimeReviews(param) {
    var sku = param.sku;
    var container = (0,react.useRef)();
    var isBrowser = "object" !== "undefined";
    var header = isBrowser ? document.querySelector("header") : 0;
    var observerConfig = {
        subtree: true,
        childList: true
    };
    var observerCallback = function(mutationList) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = mutationList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var mutation = _step.value;
                if (mutation.type === "childList") {
                    // Looks for the iframe added by the Amazon script
                    var iframe = container.current.querySelector("iframe");
                    if (iframe) {
                        // Adds header height + 10 px to the scroll margin so the content doesn't
                        // get overlapped by the floating header
                        iframe.style.scrollMarginTop = "".concat(header.offsetHeight + 10, "px");
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var observer = isBrowser ? new MutationObserver(observerCallback) : null;
    (0,react.useEffect)(function() {
        if (isBrowser) observer === null || observer === void 0 ? void 0 : observer.observe(container.current, observerConfig);
        return function() {
            if (isBrowser) observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-prime-reviews-sku": sku,
        className: "buy-with-prime-reviews-container relative m-auto w-full",
        ref: container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "amzn-roa-reviews",
            "data-site-id": "gwfxnozf54",
            "data-roa-instance-id": "w23suqokp7ni1",
            "data-sku": sku
        })
    });
}
/* harmony default export */ var products_BuyWithPrimeReviews = (BuyWithPrimeReviews);

;// CONCATENATED MODULE: ./src/snippets/products/ReviewsWrapper.jsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




function ReviewsWrapper(param) {
    var selectedVariant = param.selectedVariant, product = param.product;
    var ref;
    var isBrowser = typeof window !== "undefined";
    var amazonContainer = (0,react.useRef)(null);
    var country = (0,dist.useCountry)().country;
    var countryCode = (country === null || country === void 0 ? void 0 : country.isoCode) || "US";
    var isUs = countryCode === "US";
    var ref1 = (0,react.useState)("Site Reviews"), currentTab = ref1[0], setCurrentTab = ref1[1];
    var ref2 = (0,react.useState)([
        "Site Reviews"
    ]), reviews = ref2[0], setReviews = ref2[1];
    var buildTabs = function() {
        if (reviews.length > 1) {
            var tabs = reviews.map(function(tab) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "button button--small !min-w-0 ".concat(currentTab == tab ? "button--primary" : ""),
                    onClick: function() {
                        return setCurrentTab(tab);
                    },
                    children: tab
                });
            });
            return tabs;
        }
    };
    (0,react.useEffect)(function() {
        if (isBrowser) {
            var mutationObserver = new MutationObserver(function(mutationList) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = mutationList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var mutation = _step.value;
                        if (mutation.type === "attributes") {
                            var iframe = amazonContainer.current.querySelector("iframe");
                            var iframeHidden = iframe ? (iframe === null || iframe === void 0 ? void 0 : iframe.style["visibility"]) === "hidden" : true;
                            if (iframe && iframeHidden || !isUs) {
                                setReviews(function(prevReviews) {
                                    return prevReviews.filter(function(tab) {
                                        return tab !== "Amazon Reviews";
                                    });
                                });
                            }
                            if (isUs && iframe && !iframeHidden) {
                                setReviews(function(prevReviews) {
                                    if (prevReviews.some(function(review) {
                                        return review == "Amazon Reviews";
                                    })) {
                                        return prevReviews;
                                    }
                                    return _toConsumableArray(prevReviews).concat([
                                        "Amazon Reviews"
                                    ]);
                                });
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
            mutationObserver.observe(amazonContainer.current, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: [
                    "style"
                ]
            });
        }
        return function() {
            if (isBrowser) {
                mutationObserver.disconnect();
            }
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "reviews-wrapper",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tabs-container flex gap-5 justify-center px-5",
                children: buildTabs()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "reviews-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "yotpo-reviews ".concat(currentTab !== "Site Reviews" ? "hidden" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "pdp-yotpo-reviews-widget",
                            className: "yotpo yotpo-main-widget !mb-[44px] md:!mb-[80px]",
                            "data-product-id": product === null || product === void 0 ? void 0 : product.legacyResourceId,
                            "data-price": "$".concat(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.price),
                            "data-currency": "USD",
                            "data-name": product === null || product === void 0 ? void 0 : product.title,
                            "data-url": product === null || product === void 0 ? void 0 : product.url,
                            "data-image-url": (ref = product === null || product === void 0 ? void 0 : product.images[0]) === null || ref === void 0 ? void 0 : ref.src
                        }, product === null || product === void 0 ? void 0 : product.legacyResourceId)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: amazonContainer,
                        className: "amazon-reviews ".concat(currentTab !== "Amazon Reviews" ? "hidden" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(products_BuyWithPrimeReviews, {
                            sku: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku
                        }, "".concat(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku, "-reviews"))
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/templates/product.jsx
function product_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function product_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return product_arrayLikeToArray(arr);
}
function product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function product_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                product_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function product_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function product_toConsumableArray(arr) {
    return product_arrayWithoutHoles(arr) || product_iterableToArray(arr) || product_unsupportedIterableToArray(arr) || product_nonIterableSpread();
}
function product_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return product_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return product_arrayLikeToArray(o, minLen);
}


















function ProductTemplate(param) {
    var renderSections = param.renderSections, product = param.product;
    var ref68, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60, ref61, ref62;
    var settings = (0,dist.useSettings)();
    var sendViewProductEvent = (0,hooks/* useDataLayerActions */.KZ)().sendViewProductEvent;
    var country = (0,dist.useCountry)().country;
    var countryCode = (country === null || country === void 0 ? void 0 : country.isoCode) || "US";
    var isUs = countryCode === "US";
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var variant1 = useGetInitialVariant(product);
    var _ref = (0,dist.useProductInventoryByHandle)({
        handle: product.handle
    }), inventory = _ref.inventory, inventoryStatus = _objectWithoutProperties(_ref, [
        "inventory"
    ]);
    var metafieldMap = (0,react.useMemo)(function() {
        return (0,Metafields/* getMetafieldMap */.x)(product);
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var ref63 = (0,dist.useLocalizedVariant)({
        variant: variant1
    }), localizedVariant = ref63.localized;
    var selectedVariant = _objectSpread({}, variant1, localizedVariant);
    var ref64 = (0,react.useState)(null), selectedPlanId = ref64[0], setSelectedPlanId = ref64[1];
    var firstUpsellProduct = metafieldMap.product_upsell_1;
    var buyboxRef = (0,react.useRef)(null);
    var productInfoRef = (0,react.useRef)(null);
    var isComingSoon = metafieldMap.coming_soon;
    var router = (0,dist.useRouter)();
    var vpWidth = (0,Helper/* useWindowDimensions */.dz)().vpWidth;
    var comparePriceText = (metafieldMap === null || metafieldMap === void 0 ? void 0 : metafieldMap.custom_compare_at_price) || "";
    if (typeof history !== "undefined" && typeof history.scrollRestoration !== "undefined") {
        history.scrollRestoration = "manual";
    }
    var selectedPlan = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref68 = selectedVariant.sellingPlanAllocations) === null || ref68 === void 0 ? void 0 : ref68.find(function(plan) {
        return (plan === null || plan === void 0 ? void 0 : plan.sellingPlan.id) === selectedPlanId && isUs;
    });
    var firstPlan = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.sellingPlanAllocations) === null || ref1 === void 0 ? void 0 : ref1[0];
    var planAmount = parseFloat((selectedPlan === null || selectedPlan === void 0 ? void 0 : (ref2 = selectedPlan.priceAdjustments) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.price) === null || ref4 === void 0 ? void 0 : ref4.amount) || (firstPlan === null || firstPlan === void 0 ? void 0 : (ref5 = firstPlan.priceAdjustments) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.price) === null || ref7 === void 0 ? void 0 : ref7.amount));
    var variantAmount = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref8 = selectedVariant.priceV2) === null || ref8 === void 0 ? void 0 : ref8.amount;
    var compareAmount = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref9 = selectedVariant.compareAtPriceV2) === null || ref9 === void 0 ? void 0 : ref9.amount;
    var isLocalized = !!(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref10 = selectedVariant.priceV2) === null || ref10 === void 0 ? void 0 : ref10.locale);
    var currencySymbol = isLocalized ? (country === null || country === void 0 ? void 0 : (ref11 = country.currency) === null || ref11 === void 0 ? void 0 : ref11.symbol) || "$" : "$";
    var currencyCode = (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref12 = selectedVariant.priceV2) === null || ref12 === void 0 ? void 0 : ref12.currencyCode) || "USD";
    var sellingPlanPrice = planAmount ? "".concat(currencySymbol).concat(planAmount.toFixed(2)).replace(".00", "") : null;
    var comparePrice = compareAmount ? "".concat(currencySymbol).concat(compareAmount).replace(".00", "") : null;
    var variantPrice = "".concat(currencySymbol).concat(variantAmount).replace(".00", "");
    var planOptions = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref13 = selectedVariant.sellingPlanAllocations) === null || ref13 === void 0 ? void 0 : ref13.map(function(plan) {
        var ref, ref66, ref67;
        return {
            label: plan === null || plan === void 0 ? void 0 : (ref = plan.sellingPlan) === null || ref === void 0 ? void 0 : (ref66 = ref.name) === null || ref66 === void 0 ? void 0 : ref66.replace(/Delivery/i, ""),
            value: plan === null || plan === void 0 ? void 0 : (ref67 = plan.sellingPlan) === null || ref67 === void 0 ? void 0 : ref67.id
        };
    });
    (0,react.useEffect)(function() {
        var ref;
        if (settings === null || settings === void 0 ? void 0 : (ref = settings.subscriptions) === null || ref === void 0 ? void 0 : ref.selectSubscriptionOnLoad) {
            var ref69, ref70, ref71;
            setSelectedPlanId(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref69 = selectedVariant.sellingPlanAllocations) === null || ref69 === void 0 ? void 0 : (ref70 = ref69[0]) === null || ref70 === void 0 ? void 0 : (ref71 = ref70.sellingPlan) === null || ref71 === void 0 ? void 0 : ref71.id);
        }
    }, []);
    (0,react.useEffect)(function() {
        if (metafieldMap.display_custom_cursor === "true") {
            document.body.classList.add("show-custom-cursor");
        } else {
            document.body.classList.remove("show-custom-cursor");
        }
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        if (!selectedVariant) return;
        var search = window.location.search;
        var searchParams = new URLSearchParams(search);
        var planId = searchParams.get("selling_plan");
        var defaultSubscription = searchParams.has("subscription");
        var activePlan = (ref = selectedVariant.sellingPlanAllocations) === null || ref === void 0 ? void 0 : ref.find(function(plan) {
            return plan.sellingPlan.id.includes(planId);
        });
        if (!activePlan && defaultSubscription) {
            var ref72, ref73, ref74, ref75;
            activePlan = (ref72 = selectedVariant.sellingPlanAllocations) === null || ref72 === void 0 ? void 0 : (ref73 = ref72[0]) === null || ref73 === void 0 ? void 0 : ref73.sellingPlan;
            planId = (ref74 = selectedVariant.sellingPlanAllocations) === null || ref74 === void 0 ? void 0 : (ref75 = ref74[0]) === null || ref75 === void 0 ? void 0 : ref75.sellingPlan.id;
            delete router.query.subscription;
            router.replace({
                pathname: router.pathname,
                query: _objectSpread({}, router.query)
            }, undefined, {
                shallow: true
            });
        }
        if (activePlan) {
            setSelectedPlanId(planId);
        }
    }, [
        selectedVariant
    ]);
    var ref65 = (0,react.useMemo)(function() {
        var _sections = renderSections();
        if (!_sections) return [
            null,
            []
        ];
        var productSizesSection = _sections.filter(function(s) {
            return s.props["data-comp"] === "productsizes";
        });
        var productUpsellsSection = _sections.filter(function(s) {
            return s.props["data-comp"] === "productupsells" && vpWidth >= 1024;
        });
        var videoWiseSection = _sections.filter(function(s) {
            return s.props["data-comp"] === "VideoWise";
        });
        var otherSections = _sections.filter(function(s) {
            if (vpWidth < 1024) {
                return ![
                    "productsizes"
                ].includes(s.props["data-comp"]);
            }
            return ![
                "productsizes",
                "productupsells"
            ].includes(s.props["data-comp"]);
        });
        return [
            productSizesSection,
            productUpsellsSection,
            videoWiseSection,
            otherSections
        ];
    }, [
        renderSections,
        vpWidth
    ]), productsizes = ref65[0], productupsells = ref65[1], videowise = ref65[2], sections = ref65[3];
    var tracksInventory = product === null || product === void 0 ? void 0 : product.tracksInventory;
    var hasInventory = !tracksInventory || ((inventory === null || inventory === void 0 ? void 0 : inventory.totalInventory) || 0) > 0;
    var toggleBackInStockModal = function(e) {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent("backInStockModal:open"));
    };
    var toggleSubscriptionModal = function(e) {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent("subscriptionModal:open"));
    };
    var variantIsAvailable = (inventory === null || inventory === void 0 ? void 0 : (ref14 = inventory.variants) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id]) === null || ref15 === void 0 ? void 0 : ref15.availableForSale) && hasInventory || !tracksInventory;
    var jsonSchema = {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: product.title,
        image: product.images.map(function(image) {
            return image.src;
        }),
        description: product.description,
        brand: {
            "@type": "Brand",
            name: product.vendor.replace("_", " ")
        },
        offers: product.variants.map(function(variant) {
            return {
                "@type": "Offer",
                url: product.onlineStoreUrl,
                priceCurrency: variant.currencyCode,
                price: variant.price,
                itemCondition: "https://schema.org/NewCondition",
                availability: "https://schema.org/".concat(variant.availableForSale ? "InStock" : "OutOfStock")
            };
        })
    };
    (0,react.useMemo)(function() {
        YotpoScript();
    }, [
        product.id
    ]);
    (0,react.useEffect)(function() {
        sendViewProductEvent({
            product: product,
            selectedVariant: variant1
        });
    }, [
        variant1 === null || variant1 === void 0 ? void 0 : (ref16 = variant1.product) === null || ref16 === void 0 ? void 0 : ref16.handle,
        sendViewProductEvent
    ]);
    var discountedPrice = (0,Helper/* getDiscountedPrice */._L)(settings === null || settings === void 0 ? void 0 : settings.automaticDiscountCollections, product, selectedVariant, currencySymbol, planAmount);
    if ((discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.productPrice) && (discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.comparePrice)) {
        variantPrice = discountedPrice.productPrice;
        compareAmount = discountedPrice.comparePrice;
        comparePrice = discountedPrice.comparePrice;
        if (sellingPlanPrice && (discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.sellingPlanPrice)) {
            sellingPlanPrice = discountedPrice.sellingPlanPrice;
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-comp": "ProductTemplate",
        id: product === null || product === void 0 ? void 0 : product.legacyResourceId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-main-container flex w-full flex-col lg:container lg:mx-auto lg:flex-row",
                ref: buyboxRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-gallery mb-4 flex w-full flex-shrink-0 lg:mb-0 lg:w-7/12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGallery/* default */.Z, {
                            product: product
                        }, product.legacyResourceId)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-info-container m-auto w-full lg:m-0 lg:w-5/12",
                        ref: productInfoRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-info-inner-container m-auto max-w-[642px] p-6 pt-1 lg:m-0 lg:p-12 lg:pt-6 lg:pr-8 lg:pb-0 xl:pr-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInformation/* default */.Z, {
                                    product: product,
                                    selectedVariant: selectedVariant,
                                    selectedPlan: selectedPlan
                                }),
                                productsizes,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "block w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptions, {
                                            product: product,
                                            activeVariant: selectedVariant
                                        }),
                                        variantIsAvailable && country && isUs && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sellingPlanAllocations) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref17 = selectedVariant.sellingPlanAllocations) === null || ref17 === void 0 ? void 0 : ref17.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mb-[16px] overflow-hidden border",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    type: "button",
                                                    className: "one-time-option grid w-full grid-cols-[auto_auto_1fr] border-b bg-[#F5F5F5] px-[12px] py-[15px] md:px-[20px]  ".concat(!selectedPlanId && "bg-[#FFFFFF]"),
                                                    onClick: function() {
                                                        setSelectedPlanId(null);
                                                        window.dataLayer.push({
                                                            event: "PDP - One time select"
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "relative top-[2px] mr-[10px] flex h-[18px] w-[18px] cursor-pointer rounded-full border md:top-0 md:mr-[12px] md:h-[20px] md:w-[20px]",
                                                            children: !selectedPlanId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "relative top-[2px] left-[2px] h-[12px] w-[12px] rounded-full bg-black md:h-[14px] md:w-[14px]"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mb-0 font-hafferBold tracking-wide text-[14px]",
                                                            children: "One-time purchase"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "ml-auto font-hafferBold tracking-wide text-[14px]",
                                                            children: [
                                                                comparePrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "product-original-price mr-2 font-hafferBold tracking-wide text-[14px] text-[#757575] line-through",
                                                                            children: "".concat(comparePrice)
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "sr-only",
                                                                            children: [
                                                                                "Previous price ",
                                                                                "".concat(comparePrice)
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "".concat(variantPrice)
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "sr-only",
                                                                    children: [
                                                                        "Current price ",
                                                                        "".concat(variantPrice)
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "".concat(selectedPlanId ? "bg-[#FFFFFF]" : "bg-[#F5F5F5]"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                            type: "button",
                                                            className: "subscribe-and-save-option grid w-full grid-cols-[auto_auto_1fr] px-[12px] py-[15px] md:px-[20px]",
                                                            onClick: function() {
                                                                var ref;
                                                                setSelectedPlanId(firstPlan === null || firstPlan === void 0 ? void 0 : (ref = firstPlan.sellingPlan) === null || ref === void 0 ? void 0 : ref.id);
                                                                window.dataLayer.push({
                                                                    event: "PDP - Subscribe & Save select"
                                                                });
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "relative top-[2px] mr-[10px] flex h-[18px] w-[18px] cursor-pointer rounded-full border md:top-0 md:mr-[12px] md:h-[20px] md:w-[20px]",
                                                                    children: selectedPlanId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "relative top-[2px] left-[2px] h-[12px] w-[12px] rounded-full bg-black md:h-[14px] md:w-[14px]"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "text-left",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            className: "mb-0 font-hafferBold tracking-wide text-[14px]",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "whitespace-nowrap",
                                                                                    children: ((ref19 = firstPlan === null || firstPlan === void 0 ? void 0 : (ref18 = firstPlan.sellingPlan) === null || ref18 === void 0 ? void 0 : ref18.priceAdjustments[0]) === null || ref19 === void 0 ? void 0 : ref19.adjustmentValue) ? "Subscribe & save ".concat((ref21 = firstPlan === null || firstPlan === void 0 ? void 0 : (ref20 = firstPlan.sellingPlan) === null || ref20 === void 0 ? void 0 : ref20.priceAdjustments[0].adjustmentValue) === null || ref21 === void 0 ? void 0 : ref21.adjustmentPercentage, "%") : "Subscribe"
                                                                                }),
                                                                                (settings === null || settings === void 0 ? void 0 : (ref22 = settings.subscriptions) === null || ref22 === void 0 ? void 0 : ref22.freeShippingText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "desktop-free-shipping-text ml-[20px] hidden whitespace-nowrap bg-[#E61A4F] px-[7px] py-[4px] text-[11px] text-white xl:inline",
                                                                                    children: settings === null || settings === void 0 ? void 0 : (ref23 = settings.subscriptions) === null || ref23 === void 0 ? void 0 : ref23.freeShippingText
                                                                                })
                                                                            ]
                                                                        }),
                                                                        (settings === null || settings === void 0 ? void 0 : (ref24 = settings.subscriptions) === null || ref24 === void 0 ? void 0 : ref24.freeShippingText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "mobile-free-shipping-text whitespace-nowrap bg-[#E61A4F] px-[7px] py-[4px] font-hafferBold tracking-wide text-[11px] text-white xl:hidden",
                                                                            children: settings === null || settings === void 0 ? void 0 : (ref25 = settings.subscriptions) === null || ref25 === void 0 ? void 0 : ref25.freeShippingText
                                                                        })
                                                                    ]
                                                                }),
                                                                sellingPlanPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "ml-auto",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "product-original-price ml-4 font-hafferBold tracking-wide text-[14px] text-[#757575] line-through",
                                                                            children: "".concat(variantPrice)
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "sr-only",
                                                                            children: [
                                                                                "Previous price ",
                                                                                "".concat(variantPrice)
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "ml-2 font-hafferBold tracking-wide text-[14px]",
                                                                            children: sellingPlanPrice
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "sr-only",
                                                                            children: [
                                                                                "Current price ",
                                                                                "".concat(sellingPlanPrice)
                                                                            ]
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "ml-auto font-hafferBold tracking-wide text-[14px]",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "sr-only",
                                                                            children: "Subscription price"
                                                                        }),
                                                                        variantPrice
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "new-pdp-descriptor col-span-2 col-start-2 mb-0 hidden text-left text-[11px]",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "mr-2 bg-primary-2 px-[7px] py-1 font-hafferBold tracking-wide text-white",
                                                                            children: (settings === null || settings === void 0 ? void 0 : (ref26 = settings.subscriptions) === null || ref26 === void 0 ? void 0 : ref26.colorBadgeText) || "Most Popular!"
                                                                        }),
                                                                        (ref28 = firstPlan === null || firstPlan === void 0 ? void 0 : (ref27 = firstPlan.sellingPlan) === null || ref27 === void 0 ? void 0 : ref27.priceAdjustments[0]) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.adjustmentValue) === null || ref29 === void 0 ? void 0 : ref29.adjustmentPercentage,
                                                                        "% off + Free Shipping"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        selectedPlanId && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "px-[12px] pb-[15px] md:px-[20px]",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "mb-[8px] flex items-end whitespace-nowrap",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                            className: "text-[12px] text-black",
                                                                            htmlFor: "selling-plan-select",
                                                                            children: "Ships every:"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "select-wrap-2 relative flex flex-col",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                                                                className: "ml-2 cursor-pointer border-0 border-b bg-transparent px-2 pb-0 pr-4 pt-0 font-hafferBold tracking-wide text-[12px] text-black placeholder-black hover:placeholder-black focus:placeholder-black",
                                                                                name: "selling-plan-select",
                                                                                id: "selling-plan-select",
                                                                                value: selectedPlanId,
                                                                                onChange: function(e) {
                                                                                    setSelectedPlanId(e.target.value);
                                                                                },
                                                                                children: planOptions.map(function(option, optionIndex) {
                                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                        value: option.value,
                                                                                        children: option.label
                                                                                    }, "option-selling-plan-select-".concat(optionIndex));
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "mt-[10px] flex items-baseline whitespace-nowrap",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "text-[11px] text-black",
                                                                            children: (settings === null || settings === void 0 ? void 0 : (ref30 = settings.subscriptions) === null || ref30 === void 0 ? void 0 : ref30.cancelText) || "Cancel anytime + membership perks."
                                                                        }),
                                                                        (settings === null || settings === void 0 ? void 0 : (ref31 = settings.subscriptions) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.subscriptionModal) === null || ref32 === void 0 ? void 0 : ref32.triggerCTALabel) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "#",
                                                                            className: "ml-2 text-[11px] text-black underline",
                                                                            onClick: toggleSubscriptionModal,
                                                                            children: settings === null || settings === void 0 ? void 0 : (ref33 = settings.subscriptions) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.subscriptionModal) === null || ref34 === void 0 ? void 0 : ref34.triggerCTALabel
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "block w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "min-h-[48px] lg:min-h-[52px]",
                                            children: [
                                                variantIsAvailable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    type: "button",
                                                    className: "button button--checkout block flex flex h-[70px] w-full items-center justify-center md:px-4 md:text-[12px] lg:text-[16px]",
                                                    onClick: product_asyncToGenerator(runtime_default().mark(function _callee() {
                                                        var addItem;
                                                        return runtime_default().wrap(function _callee$(_ctx) {
                                                            while(1)switch(_ctx.prev = _ctx.next){
                                                                case 0:
                                                                    _ctx.prev = 0;
                                                                    addItem = selectedPlanId && isUs ? {
                                                                        merchandiseId: selectedVariant.id,
                                                                        sellingPlanId: btoa(selectedPlanId),
                                                                        quantity: 1,
                                                                        attributes: [
                                                                            {
                                                                                key: "_sellingPlan",
                                                                                value: selectedPlanId
                                                                            }, 
                                                                        ]
                                                                    } : {
                                                                        merchandiseId: selectedVariant.id,
                                                                        quantity: 1,
                                                                        attributes: []
                                                                    };
                                                                    if (firstUpsellProduct) {
                                                                        addItem.attributes.push({
                                                                            key: "_upsellProduct",
                                                                            value: firstUpsellProduct
                                                                        });
                                                                    }
                                                                    if (window.ShipScoutLineItemProperty) {
                                                                        addItem.attributes.push({
                                                                            key: "_sc",
                                                                            value: window.ShipScoutLineItemProperty
                                                                        });
                                                                    }
                                                                    _ctx.next = 6;
                                                                    return cartAddItem(addItem, function() {
                                                                        window.dispatchEvent(new CustomEvent("openSideCart"));
                                                                        if (selectedPlanId && isUs) {
                                                                            window.dataLayer.push({
                                                                                event: "PDP - Add_to_cart Subscribe & Save"
                                                                            });
                                                                        } else {
                                                                            window.dataLayer.push({
                                                                                event: "PDP - Add_to_cart One Time"
                                                                            });
                                                                        }
                                                                    });
                                                                case 6:
                                                                    _ctx.next = 12;
                                                                    break;
                                                                case 8:
                                                                    _ctx.prev = 8;
                                                                    _ctx.t0 = _ctx["catch"](0);
                                                                    console.error(_ctx.t0);
                                                                    alert("Something whent wrong while adding to cart, please try again.");
                                                                case 12:
                                                                case "end":
                                                                    return _ctx.stop();
                                                            }
                                                        }, _callee, null, [
                                                            [
                                                                0,
                                                                8
                                                            ]
                                                        ]);
                                                    })),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-hafferBold tracking-wide",
                                                            children: "add to cart"
                                                        }),
                                                        country && comparePrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                comparePriceText !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "ml-8 font-hafferBold tracking-wide",
                                                                    children: comparePriceText
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "product-original-price ml-4 font-hafferBold tracking-wide line-through",
                                                                    children: comparePrice
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "sr-only",
                                                                    children: [
                                                                        "Previous price ",
                                                                        "".concat(selectedPlan ? variantPrice : comparePrice)
                                                                    ]
                                                                }),
                                                                selectedPlan ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "ml-2 font-hafferBold tracking-wide",
                                                                            children: "".concat(sellingPlanPrice)
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "sr-only",
                                                                            children: [
                                                                                "Current price ",
                                                                                "".concat(sellingPlanPrice)
                                                                            ]
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "ml-2 font-hafferBold tracking-wide",
                                                                            children: variantPrice
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: "sr-only",
                                                                            children: [
                                                                                "Current price ",
                                                                                "".concat(variantPrice)
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        country && selectedPlan && sellingPlanPrice && !comparePrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "product-original-price ml-4 font-hafferBold tracking-wide line-through",
                                                                    children: variantPrice
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "ml-2 font-hafferBold tracking-wide",
                                                                    children: "".concat(sellingPlanPrice)
                                                                })
                                                            ]
                                                        }),
                                                        country && !comparePrice && !selectedPlan && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                comparePriceText !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "ml-8 font-hafferBold tracking-wide",
                                                                    children: comparePriceText
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "".concat(comparePriceText !== "" ? "ml-2" : "ml-8", " font-hafferBold tracking-wide"),
                                                                    children: variantPrice
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                inventoryStatus.success && !variantIsAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: isComingSoon !== "true" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        type: "button",
                                                        disabled: true,
                                                        className: "button button--primary block flex w-full justify-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-hafferBold tracking-wide",
                                                            children: hasInventory ? "unavailable" : "out of stock"
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "button block flex w-full justify-center border-grey-7 bg-grey-7 text-black",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "font-hafferBold tracking-wide",
                                                                    children: "Coming Soon"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_ProductEmailSignup, {})
                                                        ]
                                                    })
                                                }),
                                                isComingSoon !== "true" && inventoryStatus.success && !hasInventory && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    className: "button button--primary mt-5 block flex w-full justify-center",
                                                    onClick: toggleBackInStockModal,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "font-hafferBold tracking-wide",
                                                        children: "email me when available"
                                                    })
                                                })
                                            ]
                                        }),
                                        country && isUs && inventoryStatus.success && variantIsAvailable && isComingSoon !== "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)(products_AfterPay, {
                                            variantId: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
                                            price: variantPrice || 0,
                                            currency: currencyCode
                                        })
                                    ]
                                }),
                                country && isUs && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-6 mb-[-1.5rem] sm:mt-8 sm:mb-auto flex flex-col sm:flex-row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "productValueProp flex w-full lg:w-1/3",
                                            children: [
                                                (settings === null || settings === void 0 ? void 0 : (ref35 = settings.product) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.productValueProps) === null || ref36 === void 0 ? void 0 : ref36.value_icon_1) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "relative h-[30px] lg:h-[50px] w-[42px] lg:w-[50px] mr-0 lg:mr-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "w-[29px] lg:w-[33px]",
                                                        src: settings === null || settings === void 0 ? void 0 : (ref37 = settings.product) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.productValueProps) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.value_icon_1) === null || ref39 === void 0 ? void 0 : ref39.src,
                                                        alt: (settings === null || settings === void 0 ? void 0 : (ref40 = settings.product) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.productValueProps) === null || ref41 === void 0 ? void 0 : ref41.value_text_1) || "free shipping on all subscriptions",
                                                        loading: "lazy",
                                                        width: "33",
                                                        height: "33"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-small mt-[2px] lg:mt-auto mb-2 lg:mb-6",
                                                    children: (settings === null || settings === void 0 ? void 0 : (ref42 = settings.product) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.productValueProps) === null || ref43 === void 0 ? void 0 : ref43.value_text_1) || "free shipping on all subscriptions"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "productValueProp flex w-full lg:w-1/3",
                                            children: [
                                                (settings === null || settings === void 0 ? void 0 : (ref44 = settings.product) === null || ref44 === void 0 ? void 0 : (ref45 = ref44.productValueProps) === null || ref45 === void 0 ? void 0 : ref45.value_icon_2) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "relative h-[30px] lg:h-[50px] w-[42px] lg:w-[50px] mr-0 lg:mr-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "w-[29px] lg:w-[33px]",
                                                        src: settings === null || settings === void 0 ? void 0 : (ref46 = settings.product) === null || ref46 === void 0 ? void 0 : (ref47 = ref46.productValueProps) === null || ref47 === void 0 ? void 0 : (ref48 = ref47.value_icon_2) === null || ref48 === void 0 ? void 0 : ref48.src,
                                                        alt: (settings === null || settings === void 0 ? void 0 : (ref49 = settings.product) === null || ref49 === void 0 ? void 0 : (ref50 = ref49.productValueProps) === null || ref50 === void 0 ? void 0 : ref50.value_text_2) || "no hassle 30-day returns",
                                                        loading: "lazy",
                                                        width: "33",
                                                        height: "33"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-small mt-[2px] lg:mt-auto mb-2 lg:mb-6",
                                                    children: (settings === null || settings === void 0 ? void 0 : (ref51 = settings.product) === null || ref51 === void 0 ? void 0 : (ref52 = ref51.productValueProps) === null || ref52 === void 0 ? void 0 : ref52.value_text_2) || "no hassle 30-day returns"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "productValueProp flex w-full lg:w-1/3",
                                            children: [
                                                (settings === null || settings === void 0 ? void 0 : (ref53 = settings.product) === null || ref53 === void 0 ? void 0 : (ref54 = ref53.productValueProps) === null || ref54 === void 0 ? void 0 : ref54.value_icon_3) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "relative h-[30px] lg:h-[50px] w-[42px] lg:w-[50px] mr-0 lg:mr-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "w-[29px] lg:w-[33px]",
                                                        src: settings === null || settings === void 0 ? void 0 : (ref55 = settings.product) === null || ref55 === void 0 ? void 0 : (ref56 = ref55.productValueProps) === null || ref56 === void 0 ? void 0 : (ref57 = ref56.value_icon_3) === null || ref57 === void 0 ? void 0 : ref57.src,
                                                        alt: (settings === null || settings === void 0 ? void 0 : (ref58 = settings.product) === null || ref58 === void 0 ? void 0 : (ref59 = ref58.productValueProps) === null || ref59 === void 0 ? void 0 : ref59.value_text_3) || "rewards with every purchase",
                                                        loading: "lazy",
                                                        width: "33",
                                                        height: "33"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-small mt-[2px] lg:mt-auto mb-2 lg:mb-6",
                                                    children: (settings === null || settings === void 0 ? void 0 : (ref60 = settings.product) === null || ref60 === void 0 ? void 0 : (ref61 = ref60.productValueProps) === null || ref61 === void 0 ? void 0 : ref61.value_text_3) || "rewards with every purchase"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdp-buybox-video-wise",
                                    children: videowise
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pdp-buybox-desktop-upsells hidden lg:block",
                                    children: productupsells
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackToTop, {
                scrollReference: buyboxRef
            }),
            sections,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-[44px] mb-[10px] text-center font-tiempos text-h4-m md:mt-[100px] md:mb-[40px] md:text-h4",
                children: "Product Reviews & Questions"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsWrapper, {
                selectedVariant: selectedVariant,
                product: product
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(products_BackInStockModal, {
                selectedVariant: selectedVariant,
                product: product
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(products_SubscriptionBenefitsModal, {
                modalContent: settings === null || settings === void 0 ? void 0 : (ref62 = settings.subscriptions) === null || ref62 === void 0 ? void 0 : ref62.subscriptionModal
            }),
            inventoryStatus.success && variantIsAvailable && isComingSoon !== "true" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSticky, {
                settings: settings,
                scrollReference: productInfoRef,
                product: product,
                selectedPlan: selectedPlan,
                selectedPlanId: selectedPlanId,
                sellingPlanPrice: sellingPlanPrice,
                variantPrice: variantPrice,
                comparePrice: comparePrice
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                className: "product-schema",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(jsonSchema)
                }
            })
        ]
    }, product === null || product === void 0 ? void 0 : product.legacyResourceId);
};
var useGetInitialVariant = function(product) {
    var ref;
    var router = (0,dist.useRouter)();
    if (!product) return null;
    var legacyVariantIdQuery = router.query.variant;
    if (legacyVariantIdQuery) {
        //! Attempt to find whaproduct variant that matches the query param
        var queriedVariant = product.variants.find(function(param) {
            var legacyResourceId = param.legacyResourceId;
            return legacyResourceId === legacyVariantIdQuery;
        });
        if (queriedVariant) {
            return queriedVariant;
        }
        return product.variants[0];
    }
    //! We will find the first avaiable, and set that as the variant
    var firstAvailableVariant = product.variants.find(function(param) {
        var availableForSale = param.availableForSale;
        return availableForSale;
    });
    if (firstAvailableVariant) {
        return firstAvailableVariant;
    }
    if (product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) {
        return product.variants[0];
    }
};
function ProductOptions(param) {
    var activeVariant = param.activeVariant, product = param.product;
    var router = (0,dist.useRouter)();
    if (!product || !product.options || product.variants.length <= 1) {
        return null;
    }
    var ref = (0,react.useState)(activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.title.split(" / ").map(function(value) {
        return value.trim();
    })), selectedOptions1 = ref[0], setSelectedOptions = ref[1];
    (0,react.useEffect)(function() {
        if (selectedOptions1) {
            var variantTitle = selectedOptions1.join(" / ");
            var selectedVariant = product.variants.find(function(variant) {
                return variant.title === variantTitle;
            });
            router.push({
                pathname: router.pathname,
                query: _objectSpread({}, router.query, {
                    variant: selectedVariant.legacyResourceId
                })
            }, undefined, {
                shallow: true
            });
        }
        if ( true && window.hasOwnProperty("updateYotpoWidgets")) {
            updateYotpoWidgets();
        }
    }, [
        selectedOptions1
    ]);
    return product.options.map(function(option, nameIndex) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mb-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "text-small mb-1 font-hafferBold tracking-wide text-black",
                    children: [
                        " ",
                        option.name,
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto flex w-full",
                    children: option.values.map(function(value, valueIndex) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "w-1/6 border border py-2 px-1 font-hafferBold tracking-wide text-[12px] duration-200 hover:border-black hover:bg-grey-9 hover:text-black lg:text-base xl:text-[14px] ".concat(value === selectedOptions1[nameIndex] ? "border-black bg-grey-9 text-black" : "border-grey-4 text-grey-3"),
                            onClick: function() {
                                setSelectedOptions(function(curr) {
                                    var selectedOptions = product_toConsumableArray(curr);
                                    selectedOptions[nameIndex] = value.trim();
                                    return selectedOptions;
                                });
                            },
                            children: value
                        }, valueIndex);
                    })
                })
            ]
        }, nameIndex);
    });
}

// EXTERNAL MODULE: ./src/_components/index.js + 9 modules
var _components = __webpack_require__(42310);
;// CONCATENATED MODULE: ./src/pages/products/[handle].jsx
function _handle_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _handle_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _handle_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _handle_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _handle_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _handle_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _handle_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _handle_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _handle_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _handle_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _handle_arrayLikeToArray(o, minLen);
}

/* eslint-disable import/no-unresolved */ 




function DraftBadge() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        "data-comp": "DraftProductBadge",
        // eslint-disable-next-line react/no-unknown-property
        sx: {
            position: "fixed",
            right: 0,
            top: 175,
            transform: "rotate(-90deg)",
            transformOrigin: "bottom right",
            backgroundColor: "#433d51",
            color: "#FFF",
            px: "20px",
            py: "10px",
            fontSize: "14px",
            letterSpacing: "4px",
            fontWeight: 200
        },
        children: "DRAFT"
    });
}
var __N_SSG = true;
function Product(_param) {
    var isPreview = _param.isPreview, renderSections = _param.renderSections, props = _handle_objectWithoutProperties(_param, [
        "isPreview",
        "renderSections"
    ]);
    var router = (0,next_router.useRouter)();
    var settingProduct = (0,react.useRef)(false);
    var product = props.product;
    var ref = _slicedToArray(dist.store.recoil.useRecoilState(dist.store.state.product), 2), recoilProduct = ref[0], setProduct = ref[1];
    var hasQueryParam = router.asPath.includes("?");
    var nextQueryParamReady = Object.keys(router.query).length > 1;
    var handlesMatch = (product === null || product === void 0 ? void 0 : product.handle) === (recoilProduct === null || recoilProduct === void 0 ? void 0 : recoilProduct.handle);
    (0,react.useEffect)(function() {
        if (!handlesMatch) {
            // load the product onto the recoil state
            settingProduct.current = true;
            setProduct(product);
        } else {
            settingProduct.current = false;
        }
        return function() {
            if (hasQueryParam && !nextQueryParamReady) {
                // if we are processing query params
                return;
            }
            if (!settingProduct.current) {
                // unload the product onto the recoil state
                setProduct(null);
            }
        };
    }, [
        handlesMatch
    ]);
    var productPage = props.page;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* PageErrorBoundary */.bg, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* PageHead */.yG, {
            page: productPage,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTemplate, _handle_objectSpread({}, props, {
                        product: product,
                        renderSections: renderSections
                    })),
                    (product === null || product === void 0 ? void 0 : product.publishedAt) === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DraftBadge, {}) : null
                ]
            })
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(8718); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);